export const PROJECT_NAME = 'PressBoy';
export const SHORT_PROJECT_NAME = 'PressBoy';

export default { PROJECT_NAME, SHORT_PROJECT_NAME };
